import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

import { StorageEnum } from '@/enums/storage'
import { Institution } from '@/domain/entities/institution.entity'

export const institutionStore = create(
  persist<InstitutionStore>(
    (set) => ({
      institution: undefined,
      institutions: undefined,
      setInstitution: (institution: Institution) => {
        set({ institution })
      },
      setInstitutions: (institutions: Institution[]) => {
        set({ institutions })
      },
    }),
    {
      name: StorageEnum.institution,
      storage: createJSONStorage(() => localStorage),
    },
  ),
)

type InstitutionStore = {
  institution: Institution | undefined
  institutions: Institution[] | undefined
  setInstitution: (institution: Institution) => void
  setInstitutions: (institution: Institution[]) => void
}
